import { Injectable } from '@angular/core';
import { GeoPosition } from './../geolocation/geoposition'; // class structure only

@Injectable()
export class MonitorSession 
{
    // apiResponse.Event.
    public EventGuid:string = "";                       // apiResponse.Event.EventGuid
    public EventId:number = 0;                         // apiResponse.Event.EventId

    // apiResponse.MobileMonitor....
    // apiResponse.MobileDashboard.DashboardMonitor.....
    public MobileMonitorId:string = "";                 // apiResponse.MobileMonitor.MobileMonitorId
    public MobileMonitorTypeCode:string = "";           // e.g. HELP | MONITOR_ME
    public MobileMonitorSessionCode:string = "";        // e.g. START | IN_PROGRESS | END
    public MobileMonitorUpdatesCount:number = 0;        // 1,2,3,....
    public ActiveMonitor:boolean = false;               // e.g. is the monitor still going?
    public EventSiteId:number = 0;                      // part of GeoFence and Site Proximity to event

    // apiResponse.MobileDashboard.DashboardMonitor.....
    public MobileMonitorStatusText:string = "";           // apiResponse.MobileDashboard.DashboardMonitorStatusText
    public MobileMonitorLatestMobileDatetime:string = ""; // apiResponse.MobileDashboard.DashboardMonitorLatestMobileDatetime

    // new approach to showing log trail of messages
    public MonitorChatCount:number = 0;
    public ChatMessageArray: Array<ChatMessage> = [];

    // show the latest message in the correct sequence
    public LatestChatCount:number = 0;
    public Latest1ChatMessage:ChatMessage = new ChatMessage(); // SYSTEM | MOBILE 
    public Latest2ChatMessage:ChatMessage = new ChatMessage(); // SYSTEM | MOBILE 

    public MobileMonitorChatInTransitText:string = "";

    //apiResponse.MobileMonitor.  (DEPRECATE THIS LATER??)
    public MobileMonitorSystemMessageUser:string = "";  
    public MobileMonitorSystemMessageText:string = ""; 
    public MobileMonitorMobileMessageUser:string = "";  // "You"      
    public MobileMonitorMobileMessageText:string = "";  

    // apiResponse.MobileLocation.
    public LocationStaleAddressFlag:boolean = false;
    public LocationFormattedAddress:string = "";   
    public LocationAdminDistrict:string = "";  
    public LocationAdminDistrict2:string = "";   
    public LocationAreaVicinity:string = "";  
    public LocationAddressConfidenceLevel:string = "";   
    public GpsPositionChangedCounter:string = "";  

    public GeoPosition:GeoPosition = new GeoPosition();
}

@Injectable()
export class ChatMessage 
{
    //public ChatMessageUserName:string = "";         // You | (System User name)

    // this is the information from the API received 
    //  within apiResponse.MobileMonitor.MonitorChatMessages
    public ChatMessageText:string = "";             // "ok will do"
    public ChatReceivedFlag:boolean; // false
    public MessageChatDatetime:string = "";         // "3/19/2019 1:08:52 AM"
    public MessageChatDatetimeUtc:string = "";      // "3/19/2019 1:08:52 AM"
    public MobileMonitorActionId:number = 0;        // 12963
    public MobileMonitorChatTypeCode:string = "";   // "MOBILE"  | "SYSTEM"
    public MobileMonitorChatTypeId:number = 0;      // 3
    public SystemUserDisplayName: string = "";      // null
    public SystemUserId: number = 0;                // 0
    public SystemUserMessageFlag:boolean;           // false  (System or Mobile message)
}

